import React, { FC } from 'react'
import { ProductUsp, ProductUsps } from '@moonpig/web-shared-products'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

export const ProductUSPContent: FC<
  ProductModule & {
    usps: ProductUsps['items']
  }
> = props => {
  return (
    <ProductModuleSection {...props}>
      <ProductUsp usps={props.usps} />
    </ProductModuleSection>
  )
}
